import React from 'react';

import "./assets/scss/themes.scss";

//imoprt Route
import Route from './Routes/index';

function App() {
  return (
    <React.Fragment>
      <Route />
    </React.Fragment>
  );
}

export default App;
